import React from 'react';
import Grid from '@material-ui/core/Grid';
import SelectTextField from '../../components/SelectTextField';

export const ManagementGrid = (props) =>
    <Grid item container spacing={4}>
        <SelectTextField {...props} sm={2}/>
    </Grid>